import { Box, Stack } from '@mantine/core';
import { SettingsSwitch } from '@repo/common/components';
import { Banner } from '@repo/foundations';
import { useAuthUser } from '../../api';
import { useSuspenseFeatureAccess } from '../../api/hooks/workspace/useSuspenseFeatureAccess';
import { useUpdateWorkspace } from '../../api/hooks/workspace/useUpdateWorkspace';
import { EmptyState } from '../EmptyState';
import { UpgradeButton } from './UpgradeButton';

export function DarSettings() {
	const { workspace } = useAuthUser();
	const { mutateAsync: updateWorkspace } = useUpdateWorkspace(workspace.id);
	const { darAccess } = useSuspenseFeatureAccess();

	if (!darAccess) {
		return (
			<EmptyState
				title="Upgrade to access Access requests"
				description="You can use Access requests to centralize and manage external permissions"
				illustrationName="upgrade"
				includeGoBack={false}
				stateHeight="50vh"
				size="lg"
				withActions={<UpgradeButton feature="Access requests" size="md" />}
			/>
		);
	}

	return (
		<Stack>
			<Box>
				<SettingsSwitch
					onChange={(checked) =>
						updateWorkspace({
							data: { id: workspace.id, dar_enabled: checked },
						})
					}
					checked={workspace?.dar_enabled ?? false}
					title="Access requests"
					description="Turn on Access requests for this workspace"
					testId="access-requests-enabled-toggle"
				/>
			</Box>
			{workspace?.dar_enabled && (
				<Banner
					tone="info"
					message="Access requests are now enabled for this workspace. To start using them, you'll need to enable access requests for each supported integration"
				/>
			)}
		</Stack>
	);
}
